(function() {

    const json = document.getElementById("json");

    if (!json) {
        return;
    }

    json.textContent = JSON.stringify(
        JSON.parse(json.textContent),
        undefined,
        2
    );

})();